import Vue from 'vue'
import Router from 'vue-router'
import subRouteView from '@/components/subRouteView'
import { hasIntersect } from '@common/js/common'
import globalTitle from '../js/globalTitle'
const aderAction = () => import(/* webpackChunkName: "aderAction" */ '@/page/ader/aderAction')
const offerAction = () => import(/* webpackChunkName: "offerAction" */ '@/page/offer/offerAction')
const channelAction = () =>
  import(/* webpackChunkName: "channelAction" */ '@/page/aff/channelAction')
const offerTest = () => import(/* webpackChunkName: "offerTest" */ '@/page/ader/offerTest')
const application = () => import(/* webpackChunkName: "application" */ '@/page/offer/application')
const offerControl = () =>
  import(/* webpackChunkName: "offerControl" */ '@/page/offer/offerControl')
const smartLink = () => import(/* webpackChunkName: "smartLink" */ '@/page/offer/smartLink')
const smartLinkCreate = () =>
  import(/* webpackChunkName: "smartLinkCreate" */ '@/page/offer/smartLinkCreate')
const smartLinkSetting = () =>
  import(/* webpackChunkName: "smartLinkSetting" */ '@/page/offer/smartLinkSetting')
const affList = () => import(/* webpackChunkName: "affList" */ '@/page/aff/affList')
const affPending = () => import(/* webpackChunkName: "affPending" */ '@/page/aff/affPending')
const affCreate = () => import(/* webpackChunkName: "affCreate" */ '@/page/aff/affCreate')
const channelList = () => import(/* webpackChunkName: "channelList" */ '@/page/aff/channelList')
const affSetting = () => import(/* webpackChunkName: "affSetting" */ '@/page/aff/affSetting')
const recommend = () => import(/* webpackChunkName: "recommend" */ '@/page/aff/recommend')
const offerAccess = () => import(/* webpackChunkName: "offerAccess" */ '@/page/aff/offerAccess')
const channelCreate = () =>
  import(/* webpackChunkName: "channelCreate" */ '@/page/aff/channelCreate')
const paymentAccount = () =>
  import(/* webpackChunkName: "paymentAccount" */ '@/page/aff/paymentAccount')
const smlDeductionReport = () =>
  import(/* webpackChunkName: "smlDeductionReport" */ '@/page/payment/smlDeductionReport')
const statementList = () =>
  import(/* webpackChunkName: "statementList" */ '@/page/payment/statementList')
const asoFinance = () => import(/* webpackChunkName: "asoFinance" */ '@/page/payment/asoFinance')
const conversionUrls = () =>
  import(/* webpackChunkName: "conversionUrls" */ '@/page/aff/conversionUrls')
const sdkCallBack = () => import(/* webpackChunkName: "sdkCallBack" */ '@/page/aff/sdkCallBack')
const recommendManager = () =>
  import(/* webpackChunkName: "recommendManager" */ '@/page/aff/recommendManager')
const offerAccessSetting = () =>
  import(/* webpackChunkName: "offerAccessSetting" */ '@/page/operation/offerAccessSetting')
const automaticRules = () =>
  import(/* webpackChunkName: "automaticRules" */ '@/page/operation/automaticRules')
const channelAccess = () =>
  import(/* webpackChunkName: "channelAccess" */ '@/page/operation/channelAccess')
const offerPackage = () =>
  import(/* webpackChunkName: "offerPackage" */ '@/page/operation/offerPackage')
const offerMatch = () => import(/* webpackChunkName: "offerMatch" */ '@/page/operation/offerMatch')
const topOfferControl = () =>
  import(/* webpackChunkName: "topOfferControl" */ '@/page/operation/topOfferControl')
const jsTopOfferControl = () =>
  import(/* webpackChunkName: "jsTopOfferControl" */ '@/page/operation/jsTopOfferControl')
const channelFakeID = () =>
  import(/* webpackChunkName: "channelFakeID" */ '@/page/operation/channelFakeID')
const monitor = () => import(/* webpackChunkName: "monitor" */ '@/page/operation/monitor')
const appnameList = () =>
  import(/* webpackChunkName: "appnameList" */ '@/page/operation/appnameList')
const reportCommon = () =>
  import(/* webpackChunkName: "reportCommon" */ '@/page/report/reportCommon')
const adtrack = () => import(/* webpackChunkName: "adtrack" */ '@/page/offer/offerTest')
const trialAccount = () =>
  import(/* webpackChunkName: "trialAccount" */ '@/page/offer/trialAccount')
const smlCreative = () =>
  import(/* webpackChunkName: "smlCreative" */ '@/page/offer/smartLinkCreative')
const addCreative = () => import(/* webpackChunkName: "addCreative" */ '@/page/offer/addCreative')
const parseTid = () => import(/* webpackChunkName: "parseTid" */ '@/page/report/parseTid')
const rejectionMonitoring = () =>
  import(/* webpackChunkName: "rejectionMonitoring" */ '@/page/operation/rejectionMonitoring')
const otcDetailData = () =>
  import(/* webpackChunkName: "otcDetailData" */ '@/page/report/otcDetailData')
const snapshot = () => import(/* webpackChunkName: "snapshot" */ '@/page/snapshot')
const offerParam = () => import(/* webpackChunkName: "offerParam" */ '@/page/operation/offerParam')
const pushTraffic = () =>
  import(/* webpackChunkName: "pushTraffic" */ '@/page/operation/pushTraffic')
const carrierList = () =>
  import(/* webpackChunkName: "carrierList" */ '@/page/operation/carrierList')
const audience = () => import(/* webpackChunkName: "audience" */ '@/page/pushgo/audiences')
const sites = () => import(/* webpackChunkName: "sites" */ '@/page/pushgo/sites')
const pullAdSetting = () =>
  import(/* webpackChunkName: "pullAdSetting" */ '../page/ader/pullAdSetting')
const apkOffer = () => import(/* webpackChunkName: "apkOffer" */ '@/page/ader/apkOffer')
const eventsList = () => import(/* webpackChunkName: "eventsList" */ '@/page/website/eventsList')
const addEvent = () => import(/* webpackChunkName: "addEvent" */ '@/page/website/addEvent')
const resourceList = () =>
  import(/* webpackChunkName: "resourceList" */ '@/page/website/resourceList')
const addResource = () => import(/* webpackChunkName: "addResource" */ '@/page/website/addResource')
const newsList = () => import(/* webpackChunkName: "newsList" */ '@/page/onlineEarning/newsList')
const addNews = () => import(/* webpackChunkName: "addNews" */ '@/page/onlineEarning/addNews')
const appList = () => import(/* webpackChunkName: "appList" */ '@/page/onlineEarning/appList')
const addApp = () => import(/* webpackChunkName: "addApp" */ '@/page/onlineEarning/addApp')
const activity = () => import(/* webpackChunkName: "activity" */ '@/page/onlineEarning/activity')
const addActivity = () =>
  import(/* webpackChunkName: "addActivity" */ '@/page/onlineEarning/addActivity')
const jdDetectOffer = () =>
  import(/* webpackChunkName: "jdDetectOffer" */ '@/page/offer/jdDetectOffer')
const jdDetectResult = () =>
  import(/* webpackChunkName: "jdDetectResult" */ '@/page/offer/jdDetectResult')
const aderAsoAction = () =>
  import(/* webpackChunkName: "aderAsoAction" */ '@/page/asogrow/aderAction')
const adsList = () => import(/* webpackChunkName: "adsList" */ '@/page/ads/adsList')
const themeList = () => import(/* webpackChunkName: "themeList" */ '@/page/ads/themeList')
const biddingList = () => import(/* webpackChunkName: "biddingList" */ '@/page/oppo/biddingList')
const sortingControl = () =>
  import(/* webpackChunkName: "sortingControl" */ '@/page/ads/sortingControl')
const asotools = () => import(/* webpackChunkName: "asotools" */ '@/page/asogrow/asotools')
let notify = () => {
  let vm = router.app
  vm.notifyError(null, 'Error', 'Page load failed, please refresh and try again.')
}

// 按需加载页面组件
const aderList = () =>
  import(/* webpackChunkName: "Ader" */ '@/page/ader/aderList').catch(() => {
    notify()
  })
const createAder = () =>
  import(/* webpackChunkName: "Ader" */ '@/page/ader/createAder').catch(() => {
    notify()
  })
const createAds = () =>
  import(/* webpackChunkName: "Ads" */ '@/page/ads/createAds').catch(() => {
    notify()
  })
const createTheme = () =>
  import(/* webpackChunkName: "Ads" */ '@/page/ads/createTheme').catch(() => {
    notify()
  })
const aderSetting = () =>
  import(/* webpackChunkName: "AderSetting" */ '@/page/ader/aderSetting').catch(() => {
    notify()
  })
const aderSettingPlatform = () =>
  import(/* webpackChunkName: "AderSettingPlatform" */ '@/page/ader/aderSettingPlatform').catch(
    () => {
      notify()
    }
  )
const aderTemplate = () =>
  import(/* webpackChunkName: "AderTemplate" */ '@/page/ader/aderTemplate').catch(() => {
    notify()
  })
const domainStatistics = () =>
  import(/* webpackChunkName: "DomainStatistics" */ '@/page/ader/domainStatistics').catch(() => {
    notify()
  })
const domainManagement = () =>
  import(/* webpackChunkName: "DomainManagement" */ '@/page/ader/domainManagement').catch(() => {
    notify()
  })
const asoAder = () =>
  import(/* webpackChunkName: "asoAder" */ '@/page/asogrow/asoAder').catch(() => {
    notify()
  })
const asoAderDetail = () =>
  import(/* webpackChunkName: "asoAderDetail" */ '@/page/asogrow/asoAderDetail').catch(() => {
    notify()
  })

const asoAderInfoDetail = () =>
  import(/* webpackChunkName: "asoAderInfoDetail" */ '@/page/asogrow/asoAderInfoDetail').catch(
    () => {
      notify()
    }
  )

// offer模块
const createOffer = () =>
  import(/* webpackChunkName: "CreateOffer" */ '@/page/offer/createOffer').catch(() => {
    notify()
  })
const offerList = () =>
  import(/* webpackChunkName: "Offer" */ '@/page/offer/offerList').catch(() => {
    notify()
  })
const offerDetail = () =>
  import(/* webpackChunkName: "Offer" */ '@/page/offer/offerDetail').catch(() => {
    notify()
  })
const asoOffer = () =>
  import(/* webpackChunkName: "AsoOffer" */ '@/page/offer/asoOffer').catch(() => {
    notify()
  })
const asoOfferDetail = () =>
  import(/* webpackChunkName: "asoOfferDetail" */ '@/page/offer/asoOfferDetail').catch(() => {
    notify()
  })
const offerSetting = () =>
  import(/* webpackChunkName: "OfferSetting" */ '@/page/offer/offerSetting').catch(() => {
    notify()
  })
const offerApiList = () =>
  import(/* webpackChunkName: "OfferApi" */ '@/page/offer/offerApiList').catch(() => {
    notify()
  })
const editApiOffer = () =>
  import(/* webpackChunkName: "EditApiOffer" */ '@/page/offer/editApiOffer').catch(() => {
    notify()
  })
const importOffer = () =>
  import(/* webpackChunkName: "ImportOffer" */ '@/page/offer/importOffer.vue').catch(() => {
    notify()
  })
const pendingOffer = () =>
  import(/* webpackChunkName: "Offer" */ '@/page/offer/pendingOffer').catch(() => {
    notify()
  })
const crControl = () =>
  import(/* webpackChunkName: "Offer" */ '@/page/offer/crControl').catch(() => {
    notify()
  })
// task
const taskList = () =>
  import(/* webpackChunkName: "taskList" */ '@/page/task/taskList').catch(() => {
    notify()
  })
const taskDetail = () =>
  import(/* webpackChunkName: "taskDetail" */ '@/page/task/taskDetail').catch(() => {
    notify()
  })
const operationDetail = () =>
  import(/* webpackChunkName: "operationDetail" */ '@/page/task/operationDetail').catch(() => {
    notify()
  })
// campaign
const campaignList = () =>
  import(/* webpackChunkName: "campaignList" */ '@/page/asogrow/campaignList').catch(() => {
    notify()
  })
const campaignDetail = () =>
  import(/* webpackChunkName: "campaignDetail" */ '@/page/asogrow/campaignDetail').catch(() => {
    notify()
  })
const campaignBrushList = () =>
  import(/* webpackChunkName: "campaignBrushList" */ '@/page/asogrow/campaignBrushList').catch(
    () => {
      notify()
    }
  )
const campaignBrushDetail = () =>
  import(/* webpackChunkName: "campaignBrushDetail" */ '@/page/asogrow/campaignBrushDetail').catch(
    () => {
      notify()
    }
  )
const recordList = () =>
  import(/* webpackChunkName: "recordList" */ '@/page/asogrow/recordList').catch(() => {
    notify()
  })
const messageList = () =>
  import(/* webpackChunkName: "messageList" */ '@/page/asogrow/messageList').catch(() => {
    notify()
  })
const costList = () =>
  import(/* webpackChunkName: "costList" */ '@/page/asogrow/costList').catch(() => {
    notify()
  })
const blogList = () =>
  import(/* webpackChunkName: "blogList" */ '@/page/asogrow/blogList').catch(() => {
    notify()
  })
const blogDetail = () =>
  import(/* webpackChunkName: "blogDetail" */ '@/page/asogrow/blogDetail').catch(() => {
    notify()
  })
const asoAppList = () =>
  import(/* webpackChunkName: "asoAppList" */ '@/page/asogrow/asoAppList').catch(() => {
    notify()
  })
const asoTaskRecords = () =>
  import(/* webpackChunkName: "asoTaskRecords" */ '@/page/asogrow/taskRecords').catch(() => {
    notify()
  })
const asoCreateQuery = () =>
  import(/* webpackChunkName: "asoCreateQuery" */ '@/page/asogrow/createQuery').catch(() => {
    notify()
  })
const asoCreateQueryBatch = () =>
  import(/* webpackChunkName: "asoCreateQueryBatch" */ '@/page/asogrow/createQueryBatch').catch(
    () => {
      notify()
    }
  )
// sdk user
const userList = () =>
  import(/* webpackChunkName: "userList" */ '@/page/task/userList').catch(() => {
    notify()
  })

const exchangeSPUList = () =>
  import(/* webpackChunkName: "exchangeSPUList" */ '@/page/task/exchangeSPUList').catch(() => {
    notify()
  })

const exchangeSKUList = () =>
  import(/* webpackChunkName: "exchangeSKUList" */ '@/page/task/exchangeSKUList').catch(() => {
    notify()
  })

const spuCreate = () =>
  import(/* webpackChunkName: "spuCreate" */ '@/page/task/spuCreate').catch(() => {
    notify()
  })

const skuCreate = () =>
  import(/* webpackChunkName: "skuCreate" */ '@/page/task/skuCreate').catch(() => {
    notify()
  })

const exchangeRecordList = () =>
  import(/* webpackChunkName: "exchangeRecordList" */ '@/page/task/exchangeRecordList').catch(
    () => {
      notify()
    }
  )

const exchangeRecordDetail = () =>
  import(/* webpackChunkName: "exchangeRecordDetail" */ '@/page/task/exchangeRecordDetail').catch(
    () => {
      notify()
    }
  )

// sdk user
const pointOperationsList = () =>
  import(/* webpackChunkName: "pointOperationsList" */ '@/page/task/pointOperationsList').catch(
    () => {
      notify()
    }
  )

// Opeartion
const topOfferMonitor = () =>
  import(/* webpackChunkName: "TopOffer" */ '@/page/operation/topOfferMonitor').catch(() => {
    notify()
  })
const offerRecommend = () =>
  import(/* webpackChunkName: "OfferRecomend" */ '@/page/operation/offerRecommend').catch(() => {
    notify()
  })
// Traffic Quality
const deductionList = () =>
  import(/* webpackChunkName: "Deduction" */ '@/page/quality/deductionList').catch(() => {
    notify()
  })
const createDeduction = () =>
  import(/* webpackChunkName: "Deduction" */ '@/page/quality/createDeduction').catch(() => {
    notify()
  })
const importDeductionModal = () =>
  import(/* webpackChunkName: "Deduction" */ '@/page/quality/importDeductionModal').catch(() => {
    notify()
  })
const deductionNotification = () =>
  import(/* webpackChunkName: "Deduction" */ '@/page/quality/deductionNotification').catch(() => {
    notify()
  })
const antiFraud = () =>
  import(/* webpackChunkName: "antiFraud" */ '@/page/quality/antiFraud').catch(() => {
    notify()
  })
const siteidBlack = () =>
  import(/* webpackChunkName: "siteidBlack" */ '@/page/quality/siteidBlack').catch(() => {
    notify()
  })
const qualityFeedback = () =>
  import(/* webpackChunkName: "qualityFeedback" */ '@/page/quality/qualityFeedback').catch(() => {
    notify()
  })
const qualityFeedbackCreate = () =>
  import(/* webpackChunkName: "qualityFeedback" */ '@/page/quality/qualityFeedbackCreate').catch(
    () => {
      notify()
    }
  )
const feedback = () =>
  import(/* webpackChunkName: "feedback" */ '@/page/feedback/feedback').catch(() => {
    notify()
  })
const support = () =>
  import(/* webpackChunkName: "feedback" */ '@/page/feedback/support').catch(() => {
    notify()
  })
// 权限管理
const users = () =>
  import(/* webpackChunkName: "Perm" */ '@/page/perm/user').catch(() => {
    notify()
  })
const teams = () =>
  import(/* webpackChunkName: "Perm" */ '@/page/perm/team').catch(() => {
    notify()
  })
const roles = () =>
  import(/* webpackChunkName: "Perm" */ '@/page/perm/role').catch(() => {
    notify()
  })
const roleSetting = () =>
  import(/* webpackChunkName: "Perm" */ '@/page/perm/roleSetting').catch(() => {
    notify()
  })

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: snapshot,
      meta: {
        title: 'Dashboard',
      },
    },
    {
      path: '/snapshot',
      name: 'snapshot',
      component: snapshot,
      meta: {
        title: 'Dashboard',
        permList: false,
      },
    },
    /* Interactive Ads */
    {
      path: '/ads',
      component: subRouteView(),
      children: [
        {
          path: 'list',
          name: 'ads-list',
          component: adsList,
          menu: globalTitle.Interactive_Ads,
          meta: {
            title: 'Creatives',
            // permList: ['ads.view_list'],
            permList: ['ader.view_list'],
          },
        },
        {
          path: 'create',
          name: 'create-ads',
          component: createAds,
          meta: {
            title: 'Create Creative',
          },
        },
        {
          path: 'detail/:id',
          name: 'edit-ads',
          component: createAds,
          meta: {
            title: 'Edit Creative',
          },
        },
        {
          path: 'sorting',
          name: 'sorting-control',
          component: sortingControl,
          menu: globalTitle.Interactive_Ads,
          meta: {
            title: 'Sorting',
            permList: ['ader.view_list'],
          },
        },
        {
          path: 'themes',
          name: 'themes-list',
          component: themeList,
          menu: globalTitle.Interactive_Ads,
          meta: {
            title: 'Themes',
            permList: ['ader.view_list'],
          },
        },
        {
          path: 'theme-create',
          name: 'create-theme',
          component: createTheme,
          meta: {
            title: 'Create Theme',
          },
        },
        {
          path: 'theme-create/:id',
          name: 'edit-theme',
          component: createTheme,
          meta: {
            title: 'Edit Theme',
          },
        },
      ],
    },
    // oppo reach
    {
      path: '/bidding',
      component: subRouteView(),
      children: [
        {
          path: 'list',
          name: 'bidding-list',
          component: biddingList,
          menu: globalTitle.OPPO_Reach,
          meta: {
            title: 'Bidding Price',
            permList: ['ader.view_list'],
          },
        },
      ],
    },
    /* Advertiser */
    {
      path: '/ader',
      component: subRouteView(),
      children: [
        {
          path: 'list',
          name: 'ader-list',
          component: aderList,
          menu: globalTitle.ADVERTISER,
          meta: {
            title: 'Advertiser',
            permList: ['ader.view_list'],
          },
        },
        {
          path: 'create',
          name: 'create-ader',
          component: createAder,
          meta: {
            title: 'Advertiser Create',
          },
        },
        {
          path: 'edit/:aderId/:momp_status',
          component: aderAction,
          children: [
            {
              path: '',
              name: 'edit-ader',
              component: createAder,
              meta: {
                title: 'Advertiser Detail',
              },
            },
          ],
        },
        {
          path: 'setting/:aderId/:momp_status',
          component: aderAction,
          children: [
            {
              path: '',
              name: 'ader-setting',
              component: aderSetting,
              meta: {
                title: 'Advertiser Setting',
              },
            },
          ],
        },
        {
          path: 'api/:aderId/:momp_status',
          component: aderAction,
          children: [
            {
              path: '',
              name: 'pull_ad_setting',
              component: pullAdSetting,
              meta: {
                title: 'Create API',
                permList: ['ader.view_pull_setting'],
              },
            },
          ],
        },
        {
          path: 'apk/:aderId/:momp_status',
          component: aderAction,
          children: [
            {
              path: '',
              name: 'apk_offer',
              component: apkOffer,
              meta: {
                title: 'APK Offer',
                permList: ['ader.view_pull_setting'],
              },
            },
          ],
        },
      ],
    },
    {
      path: '/aderSetting/platform/:aderId/:momp_status',
      name: 'ader-setting-platform',
      component: aderSettingPlatform,
      meta: {
        title: 'Advertiser Setting',
      },
    },
    {
      path: '/ader/offer-test',
      name: 'offer-test',
      component: offerTest,
      menu: globalTitle.ADVERTISER,
      meta: {
        title: 'Advertiser Test',
        permList: ['ader.view_of_test'],
      },
    },
    {
      path: '/ader/advertiser-template',
      name: 'ader-template',
      component: aderTemplate,
      menu: globalTitle.ADVERTISER,
      meta: {
        title: 'Template Setting',
        permList: ['ader.view_template_setting'],
      },
    },
    {
      path: '/ader/domain-statistics',
      name: 'domain-statistics',
      component: domainStatistics,
      menu: globalTitle.ADVERTISER,
      meta: {
        title: 'Domain Statistics',
        permList: ['ader.view_domain_statistics'],
      },
    },
    {
      path: '/ader/domain-management',
      name: 'domain-management',
      component: domainManagement,
      menu: globalTitle.ADVERTISER,
      meta: {
        title: 'Domain Management',
        permList: ['ader.view_domain_management'],
      },
    },
    /* AsoAder */
    {
      path: '/aso-ader',
      component: subRouteView(),
      children: [
        {
          path: 'list',
          name: 'aso-ader-list',
          component: asoAder,
          menu: globalTitle.SELF_SERVICE,
          meta: {
            title: 'ASO Advertiser',
            permList: ['self_service.view_aso_advertiser_list'],
          },
        },
        {
          path: 'detail/:aderId/:momp_status',
          component: aderAsoAction,
          children: [
            {
              path: '',
              name: 'aso-ader-detail',
              component: asoAderDetail,
              meta: {
                title: 'ASO Advertiser MOMP',
                permList: ['self_service.view_aso_advertiser_list'],
              },
            },
          ],
        },
        {
          path: 'create/:aderId/:momp_status',
          component: aderAsoAction,
          children: [
            {
              path: '',
              name: 'create-aso-ader',
              component: asoAderDetail,
              meta: {
                title: 'ASO Advertiser MOMP',
                permList: ['self_service.view_aso_advertiser_list'],
              },
            },
          ],
        },
        {
          path: 'infoDetail/:aderId/:momp_status',
          component: aderAsoAction,
          children: [
            {
              path: '',
              name: 'aso-ader-info-detail',
              component: asoAderInfoDetail,
              meta: {
                title: 'ASO Advertiser Info',
                permList: ['self_service.view_aso_advertiser_list'],
              },
            },
          ],
        },
        {
          path: 'infoDetail/create',
          component: aderAsoAction,
          children: [
            {
              path: '',
              name: 'aso-ader-info-create',
              component: asoAderInfoDetail,
              meta: {
                title: 'ASO Advertiser Info',
                permList: ['self_service.view_aso_advertiser_list'],
              },
            },
          ],
        },
      ],
    },
    {
      path: '/aso/app',
      name: 'aso_app',
      component: asoAppList,
      menu: globalTitle.SELF_SERVICE,
      meta: {
        title: 'App',
        permList: ['self_service.view_app_list'],
      },
    },
    /* Offer */
    {
      path: '/offer/api',
      component: subRouteView(),
      children: [
        {
          path: 'list',
          name: 'offer-api-list',
          component: offerApiList,
          menu: globalTitle.OFFER,
          meta: {
            title: 'API Offer',
            permList: ['offer.view_api_offer'],
          },
        },
        {
          path: 'detail/:id',
          name: 'api-offer-detail',
          component: offerDetail,
          meta: {
            title: 'API Offer Detail',
            permList: ['offer.view_api_offer'],
          },
        },
        {
          path: 'edit/:id',
          name: 'edit-api-offer',
          component: editApiOffer,
          meta: {
            title: 'Edit API Offer',
            permList: ['offer.edit_api_offer'],
          },
        },
      ],
    },
    /* ASO Offer */
    {
      path: '/offer/aso',
      component: subRouteView(),
      children: [
        {
          path: 'list',
          name: 'aso-offer-list',
          component: asoOffer,
          menu: globalTitle.OFFER,
          meta: {
            title: 'ASO Offer',
            permList: ['offer.view_aso_offer'],
          },
        },
        {
          path: 'detail/:id',
          name: 'aso-offer-detail',
          component: asoOfferDetail,
          meta: {
            title: 'ASO Offer Detail',
            permList: ['offer.view_aso_offer'],
          },
        },
        {
          path: 'create',
          name: 'aso-offer-create',
          component: asoOfferDetail,
          meta: {
            title: 'Create ASO Offer',
            permList: ['offer.create_aso_offer'],
          },
        },
        {
          path: 'edit/:id',
          name: 'aso-offer-edit',
          component: asoOfferDetail,
          meta: {
            title: 'Edit ASO Offer',
            permList: ['offer.edit_aso_offer'],
          },
        },
      ],
    },
    {
      path: '/offer',
      component: subRouteView(),
      children: [
        {
          path: 'list',
          name: 'offer-list',
          component: offerList,
          menu: globalTitle.OFFER,
          meta: {
            title: 'Effective Offer',
            permList: ['offer.view_list'],
          },
        },
        {
          path: 'create',
          name: 'create-offer',
          component: createOffer,
          meta: {
            title: 'Create Offer',
          },
        },
        {
          path: 'detail/:id',
          component: offerAction,
          children: [
            {
              path: '',
              name: 'offer-detail',
              component: offerDetail,
              meta: {
                title: 'Offer Detail',
              },
            },
          ],
        },
        {
          path: 'edit/:id',
          component: offerAction,
          children: [
            {
              path: '',
              name: 'edit-offer',
              component: createOffer,
              meta: {
                title: 'Edit Offer',
              },
            },
          ],
        },
        {
          path: 'copy/:id',
          component: offerAction,
          children: [
            {
              path: '',
              name: 'copy-offer',
              component: createOffer,
              meta: {
                title: 'Copy Offer',
              },
            },
          ],
        },
        {
          path: 'setting/:id',
          component: offerAction,
          children: [
            {
              path: '',
              name: 'offer-setting',
              component: offerSetting,
              meta: {
                title: 'Offer Setting',
              },
            },
          ],
        },
      ],
    },
    {
      path: '/offer/import',
      name: 'import-offer',
      component: importOffer,
      meta: {
        title: 'Import Offer',
        permList: ['offer.import_offers'],
      },
    },
    {
      path: '/offer/pending',
      name: 'pending-offer',
      component: pendingOffer,
      menu: globalTitle.OFFER,
      meta: {
        title: 'Pending Offer',
        permList: ['offer.pending_view_list'],
      },
    },
    {
      path: '/offer/smartlink',
      component: subRouteView(),
      children: [
        {
          path: '',
          name: 'smart-link',
          component: smartLink,
          menu: globalTitle.OFFER,
          meta: {
            title: 'SmartLink',
            permList: ['offer.view_sml'],
          },
        },
        {
          path: 'create/:sml_id',
          name: 'smart-link-create',
          component: smartLinkCreate,
          meta: {
            title: 'Create SmartLink',
            permList: ['offer.create_sml'],
          },
        },
        {
          path: 'edit/:sml_id',
          name: 'smart-link-edit',
          component: smartLinkCreate,
          meta: {
            title: 'Edit Smart Link',
            permList: ['offer.edit_sml'],
          },
        },
        {
          path: 'setting/:sml_id',
          name: 'smart-link-setting',
          component: smartLinkSetting,
          meta: {
            title: 'Smart Link Setting',
            permList: ['offer.sml_setting'],
          },
        },
      ],
    },
    {
      path: '/offer/application/',
      name: 'offer-application',
      component: application,
      menu: globalTitle.OFFER,
      meta: {
        title: 'Application',
        permList: ['offer.application_view'],
      },
    },
    {
      path: '/offer-control',
      component: subRouteView(),
      children: [
        {
          path: 'offer-package-list',
          component: offerControl,
          menu: globalTitle.OFFER,
          meta: {
            title: 'Offer Control',
            permList: ['offer.view_offer_control'],
          },
          children: [
            {
              path: '',
              name: 'offer-package-list',
              component: offerPackage,
              meta: {
                title: 'API Package Setting',
                permList: ['offer.offer_package'],
              },
            },
          ],
        },
        {
          path: 'offer-match',
          component: offerControl,
          children: [
            {
              path: '',
              name: 'offer-match',
              component: offerMatch,
              meta: {
                title: 'Offer Match',
                permList: ['offer.offer_match'],
              },
            },
          ],
        },
        {
          path: 'offer-recommend',
          component: offerControl,
          children: [
            {
              path: '',
              name: 'offer-recommend',
              component: offerRecommend,
              meta: {
                title: 'Manual recommend',
                permList: ['offer.offer_recommend'],
              },
            },
          ],
        },
        {
          path: 'top-offer-control',
          component: offerControl,
          children: [
            {
              path: '',
              name: 'top-offer-control',
              component: topOfferControl,
              meta: {
                title: 'Top Offer Control',
                permList: ['offer.top_offer_control'],
              },
            },
          ],
        },
        {
          path: 'js-top-offer-control',
          component: offerControl,
          children: [
            {
              path: '',
              name: 'js-top-offer-control',
              component: jsTopOfferControl,
              meta: {
                title: 'JS Top Offer Control',
                permList: ['offer.js_top_offer_control'],
              },
            },
          ],
        },
        {
          path: 'top-offer-monitor',
          component: offerControl,
          children: [
            {
              path: '',
              name: 'top-offer-monitor',
              component: topOfferMonitor,
              meta: {
                title: 'Top Offer Monitor',
                permList: ['offer.top_offer_monitor'],
              },
            },
          ],
        },
        {
          path: 'cr-control',
          component: offerControl,
          children: [
            {
              path: '',
              name: 'cr-control',
              component: crControl,
              meta: {
                title: 'CR Control',
                permList: ['offer.cr_control'],
              },
            },
          ],
        },
        {
          path: 'offer-param',
          component: offerControl,
          children: [
            {
              path: '',
              name: 'offer-param',
              component: offerParam,
              meta: {
                title: 'MCG Offer Creative',
                permList: ['offer.offer_param'],
              },
            },
          ],
        },
      ],
    },
    {
      path: '/euler',
      name: 'euler',
      component: adtrack,
      menu: globalTitle.OFFER,
      meta: {
        title: 'Offer Detect',
        permList: ['offer.offer_detect'],
      },
    },
    {
      path: '/jd-detect-offer/',
      name: 'jd-detect-offer',
      component: jdDetectOffer,
      menu: globalTitle.OFFER,
      meta: {
        title: 'JDDetect Offer',
        permList: ['offer.offer_detect'],
      },
    },
    {
      path: '/jd-detect-offer/result/',
      name: 'jd-detect-result',
      component: jdDetectResult,
      meta: {
        title: 'Result',
        permList: ['offer.offer_detect'],
      },
    },
    {
      path: '/trial_account',
      name: 'trial_account',
      component: trialAccount,
      menu: globalTitle.OFFER_DETECT,
      meta: {
        title: 'Trial Account',
        permList: ['offer_detect.edit_trail_account'],
      },
    },
    /* Task */
    {
      path: '/task/list',
      name: 'task_list',
      component: taskList,
      menu: globalTitle.SDK,
      meta: {
        title: 'Task List',
        permList: ['sdk.view_task_list'],
      },
    },
    {
      path: '/task/create',
      name: 'taskAdd',
      component: taskDetail,
      meta: {
        title: 'Create Task',
      },
    },
    {
      path: '/task/detail/:id',
      name: 'taskEdit',
      component: taskDetail,
      meta: {
        title: 'Edit Task',
      },
    },
    {
      path: '/sdk/users',
      name: 'sdkUsers',
      component: userList,
      menu: globalTitle.SDK,
      meta: {
        title: 'SDK Users',
        permList: ['sdk.view_user_list'],
      },
    },
    {
      path: '/sdk/exchangeSPU',
      name: 'sdkExchangeSPU',
      component: exchangeSPUList,
      menu: globalTitle.SDK,
      meta: {
        title: 'Exchange Item SPU',
        permList: ['sdk.view_exchange_spu_list'],
      },
    },
    {
      path: '/exchangeSPU/create',
      name: 'sdkExchangeSPUAdd',
      component: spuCreate,
      meta: {
        title: 'Create Item SPU',
      },
    },
    {
      path: '/exchangeSPU/edit/:id',
      name: 'sdkExchangeSPUEdit',
      component: spuCreate,
      meta: {
        title: 'Edit Item SPU',
      },
    },
    {
      path: '/sdk/exchangeSKU',
      name: 'sdkExchangeSKU',
      component: exchangeSKUList,
      menu: globalTitle.SDK,
      meta: {
        title: 'Exchange Item SKU',
        permList: ['sdk.view_exchange_sku_list'],
      },
    },
    {
      path: '/exchangeSKU/create',
      name: 'sdkExchangeSKUAdd',
      component: skuCreate,
      meta: {
        title: 'Create Item SKU',
      },
    },
    {
      path: '/exchangeSKU/edit/:id',
      name: 'sdkExchangeSKUEdit',
      component: skuCreate,
      meta: {
        title: 'Edit Item SKU',
      },
    },
    {
      path: '/sdk/exchangeRecords',
      name: 'sdkExchangeRecord',
      component: exchangeRecordList,
      menu: globalTitle.SDK,
      meta: {
        title: 'Exchange Record',
        permList: ['sdk.view_exchange_record_list'],
      },
    },
    {
      path: '/exchangeRecords/detail/:id',
      name: 'sdkExchangeRecordDetail',
      component: exchangeRecordDetail,
      meta: {
        title: 'Exchange Record Detail',
        permList: ['sdk.view_exchange_record_list'],
      },
    },
    {
      path: '/sdk/operations',
      name: 'pointsOperations',
      component: pointOperationsList,
      menu: globalTitle.SDK,
      meta: {
        title: 'Points Operations',
        permList: ['sdk.view_operations_list'],
      },
    },
    {
      path: '/operation/create',
      name: 'operationAdd',
      component: operationDetail,
      meta: {
        title: 'Create Operation',
      },
    },
    {
      path: '/operation/detail/:id',
      name: 'operationDetail',
      component: operationDetail,
      meta: {
        title: 'Operation Detail',
      },
    },
    {
      path: '/operation/edit/:id',
      name: 'operationEdit',
      component: operationDetail,
      meta: {
        title: 'Edit Operation',
      },
    },
    {
      path: '/campaign',
      component: subRouteView(),
      children: [
        {
          path: 'list',
          name: 'campaign_list',
          component: campaignList,
          menu: globalTitle.SELF_SERVICE,
          meta: {
            title: 'Campaign',
            permList: ['self_service.view_campaign_list'],
          },
        },
        {
          path: 'detail/:id',
          name: 'campaign_detail',
          component: campaignDetail,
          meta: {
            title: 'Campaign Detail',
            permList: ['self_service.view_campaign_list'],
          },
        },
      ],
    },
    {
      path: '/campaign/brush/list',
      name: 'campaign_brush_list',
      component: campaignBrushList,
      menu: globalTitle.SELF_SERVICE,
      meta: {
        title: 'Brush Campaign',
        permList: ['self_service.view_campaign_list'],
      },
    },
    {
      path: '/campaign/brush/detail/:id',
      name: 'campaign_brush_detail',
      component: campaignBrushDetail,
      meta: {
        title: 'Brush Campaign Detail',
        permList: ['self_service.view_campaign_list'],
      },
    },
    {
      path: '/record/list',
      name: 'record_list',
      component: recordList,
      menu: globalTitle.SELF_SERVICE,
      meta: {
        title: 'Record',
        permList: ['self_service.view_record_list'],
      },
    },
    {
      path: '/message/list',
      name: 'message_list',
      component: messageList,
      menu: globalTitle.SELF_SERVICE,
      meta: {
        title: 'Message',
        permList: ['self_service.view_message_list'],
      },
    },
    {
      path: '/blog/list',
      name: 'blog_list',
      component: blogList,
      menu: globalTitle.SELF_SERVICE,
      meta: {
        title: 'Blog',
        permList: ['self_service.view_blog_list'],
      },
    },
    {
      path: '/blog/create',
      name: 'blogCreate',
      component: blogDetail,
      meta: {
        title: 'Create Blog',
        permList: ['self_service.view_blog_list'],
      },
    },
    // {
    //   path: '/holidayActivity',
    //   name: 'holidayActivity',
    //   component: holidayActivity,
    //   menu: globalTitle.SELF_SERVICE,
    //   meta: {
    //     title: 'Holiday Activity',
    //     permList: ['self_service.view_blog_list'],
    //   },
    // },
    {
      path: '/blog/detail/:id',
      name: 'blogDetail',
      component: blogDetail,
      meta: {
        title: 'Blog Detail',
        permList: ['self_service.view_blog_list'],
      },
    },
    {
      path: '/cost/list',
      name: 'cost_list',
      component: costList,
      menu: globalTitle.SELF_SERVICE,
      meta: {
        title: 'Manual Campaign Cost',
        permList: ['self_service.view_manual_campaign_cost_list'],
      },
    },
    {
      path: '/aso/tools',
      component: asotools,
      menu: globalTitle.SELF_SERVICE,
      meta: {
        title: 'ASO Tools',
        permList: ['self_service.view_campaign_list'],
      },
      children: [
        {
          path: '',
          redirect: { name: 'aso-batch-create-query' },
        },
        {
          path: 'records',
          name: 'aso-task-records',
          component: asoTaskRecords,
          meta: {
            title: 'Task Records',
            permList: ['self_service.view_campaign_list'],
          },
        },
        {
          path: 'create',
          redirect: { name: 'aso-batch-create-query' },
        },
        {
          path: 'edit',
          name: 'aso-edit-query-campaign',
          component: asoCreateQuery,
          meta: {
            title: 'Create Query',
            permList: ['self_service.view_campaign_list'],
          },
        },
        {
          path: 'edit/:id',
          redirect: to => ({
            name: 'aso-batch-edit-query',
            params: { id: to.params.id },
          }),
        },
        {
          path: 'batchCreate',
          name: 'aso-batch-create-query',
          component: asoCreateQueryBatch,
          meta: {
            title: 'Create Query',
            permList: ['self_service.view_campaign_list'],
          },
        },
        {
          path: 'batchEdit/:id',
          name: 'aso-batch-edit-query',
          component: asoCreateQueryBatch,
          meta: {
            title: 'Edit Query',
            permList: ['self_service.view_campaign_list'],
          },
        },
      ],
    },
    /* Publisher */
    {
      path: '/aff',
      name: 'aff',
      component: subRouteView(),
      children: [
        {
          path: 'list',
          name: 'aff-list',
          component: affList,
          menu: globalTitle.AFFILIATE,
          meta: {
            title: 'Publisher',
            permList: ['aff.view_list'],
          },
        },
        {
          path: 'create/',
          name: 'aff-create',
          component: affCreate,
          meta: {
            title: 'Create Publisher',
          },
        },
        {
          path: 'detail/:aff_id',
          name: 'aff-detail',
          component: affCreate,
          meta: {
            title: 'Publish Detail',
          },
        },
      ],
    },
    {
      path: '/aff/sdk-callback',
      name: 'sdk-callback',
      component: sdkCallBack,
      menu: globalTitle.AFFILIATE,
      meta: {
        title: 'SDK Callback',
        permList: ['aff.sdk_callback'],
      },
    },
    {
      path: '/channel',
      name: 'channel',
      component: subRouteView(),
      children: [
        {
          path: 'list/',
          name: 'aff-channel',
          component: channelList,
          menu: globalTitle.AFFILIATE,
          meta: {
            title: 'Channel',
            permList: ['aff.view_channel'],
          },
        },
        {
          path: 'create/:aff_id/',
          name: 'channel-create',
          component: channelCreate,
          meta: {
            title: 'Channel Create',
          },
        },
        {
          path: 'detail/:aff_id/:channel_id/',
          component: channelAction,
          children: [
            {
              path: '',
              name: 'channel-detail',
              component: channelCreate,
              meta: {
                title: 'Edit Channel',
              },
            },
          ],
        },
        {
          path: 'setting/:aff_id/:channel_id/',
          component: channelAction,
          children: [
            {
              path: '',
              name: 'aff-setting',
              component: affSetting,
              meta: {
                title: 'Channel Setting',
              },
            },
          ],
        },
        {
          path: 'recommend/:aff_id/:channel_id/',
          component: channelAction,
          children: [
            {
              path: '',
              name: 'recommend',
              component: recommend,
              meta: {
                title: 'Recommend',
              },
            },
          ],
        },
        {
          path: 'access/:aff_id/:channel_id/',
          component: channelAction,
          children: [
            {
              path: '',
              name: 'offer-access',
              component: offerAccess,
              meta: {
                title: 'Offer Access',
              },
            },
          ],
        },
      ],
    },
    {
      path: '/aff/pending',
      name: 'aff-pending',
      component: affPending,
      menu: globalTitle.AFFILIATE,
      meta: {
        title: 'Pending Publisher',
        permList: ['aff.view_pending'],
      },
    },
    {
      path: '/aff/payment-account',
      name: 'payment-account',
      component: paymentAccount,
      menu: globalTitle.AFFILIATE,
      meta: {
        title: 'Payment Account',
        permList: ['aff.view_account'],
      },
    },
    {
      path: '/aff/conversion-urls',
      name: 'conversion-urls',
      component: conversionUrls,
      menu: globalTitle.AFFILIATE,
      meta: {
        title: 'Publisher Test',
        permList: ['aff.testing'],
      },
    },
    {
      path: '/aff/recommend-manager',
      name: 'recommend-manager',
      component: recommendManager,
      menu: globalTitle.AFFILIATE,
      meta: {
        title: 'Commission',
        permList: ['aff.recommend_manage'],
      },
    },
    /* Finance */
    {
      path: '/finance',
      component: subRouteView(),
      children: [
        {
          path: 'deduction',
          name: 'deduction-list',
          component: deductionList,
          menu: globalTitle.FINANCE,
          meta: {
            title: 'Deduction List',
            permList: ['traffic_quality.view_list'],
          },
        },
        {
          path: 'deduction/create',
          name: 'create-deduction',
          component: createDeduction,
          meta: {
            title: 'Create Deduction/Pending',
          },
        },
        {
          path: 'deduction/import',
          name: 'import-deduction',
          component: importDeductionModal,
          meta: {
            title: 'Quick Create Deduction/Pending',
          },
        },
        {
          path: 'deduction/notification',
          name: 'deduction-notification',
          component: deductionNotification,
          menu: globalTitle.FINANCE,
          meta: {
            title: 'Deduction Notification',
            permList: ['traffic_quality.view_deduct_notification_list'],
          },
        },
      ],
    },
    {
      path: '/payment/statement/',
      name: 'statement-list',
      component: statementList,
      menu: globalTitle.FINANCE,
      meta: {
        title: 'Statement',
        permList: ['payment.view_statement'],
      },
    },
    {
      path: '/payment/aso-finance/',
      name: 'aso-finance',
      component: asoFinance,
      menu: globalTitle.FINANCE,
      meta: {
        title: 'ASO Finance',
        permList: ['payment.view_aso_finance'],
      },
    },
    {
      path: '/payment/sml-deduction/',
      name: 'smlDeductionReport',
      component: smlDeductionReport,
      meta: {
        title: 'SML Deduction Report',
      },
    },
    /* Traffic Quality */
    {
      path: '/quality/feedback',
      component: subRouteView(),
      children: [
        {
          path: 'list',
          name: 'quality-feedback',
          component: qualityFeedback,
          menu: globalTitle.TRAFFIC_QUALITY,
          meta: {
            title: 'Quality Feedback',
            permList: ['traffic_quality.feedback'],
          },
        },
        {
          path: 'create',
          name: 'quality-feedback-create',
          component: qualityFeedbackCreate,
          meta: {
            title: 'Create Feedback',
          },
        },
        {
          path: 'update/:id',
          name: 'quality-feedback-update',
          component: qualityFeedbackCreate,
          meta: {
            title: 'Update Feedback',
          },
        },
        {
          path: 'detail/:id',
          name: 'quality-feedback-detail',
          component: qualityFeedbackCreate,
          meta: {
            title: 'Feedback detail',
          },
        },
      ],
    },
    {
      path: '/quality',
      component: subRouteView(),
      children: [
        {
          path: 'anti-fraud',
          name: 'antiFraud',
          component: antiFraud,
          menu: globalTitle.TRAFFIC_QUALITY,
          meta: {
            title: 'S2S Anti Fraud',
            permList: ['traffic_quality.chn_list'],
          },
        },
        {
          path: 'siteid-blacklist',
          name: 'siteidBlack',
          component: siteidBlack,
          menu: globalTitle.TRAFFIC_QUALITY,
          meta: {
            title: 'Sub Channel Blacklist',
            permList: ['traffic_quality.blist'],
          },
        },
      ],
    },
    /* Setup */
    {
      path: '/operation/channel-access/',
      name: 'channel-access',
      component: channelAccess,
      menu: globalTitle.SETTING,
      meta: {
        title: 'Channel Access',
        permList: ['setting.view_rules'],
      },
    },
    {
      path: '/operation/automatic-rules/',
      name: 'automatic-rules',
      component: automaticRules,
      menu: globalTitle.SETTING,
      meta: {
        title: 'Automatic Rules',
        permList: ['setting.view_rules'],
      },
    },
    {
      path: '/operation/offer-access-setting/',
      name: 'offer-access-setting',
      component: offerAccessSetting,
      menu: globalTitle.SETTING,
      meta: {
        title: 'API Offer Access',
        permList: ['setting.offer_access'],
      },
    },
    {
      path: '/operation/channel-fakeid/',
      name: 'channel-fakeid',
      component: channelFakeID,
      menu: globalTitle.SETTING,
      meta: {
        title: 'Fake List',
        permList: ['setting.channel_fake_id'],
      },
    },
    {
      path: '/operation/resource',
      name: 'appname-list',
      component: appnameList,
      menu: globalTitle.SETTING,
      meta: {
        title: 'App Name List',
        permList: ['setting.resource'],
      },
    },
    {
      path: '/operation/push-traffic/',
      name: 'push-traffic',
      component: pushTraffic,
      menu: globalTitle.SETTING,
      meta: {
        title: 'Push Traffic',
        permList: ['setting.push_traffic'],
      },
    },
    {
      path: '/operation/carrier-list/',
      name: 'carrier-list',
      component: carrierList,
      menu: globalTitle.SETTING,
      meta: {
        title: 'Carrier List',
        permList: ['setting.carrier_list'],
      },
    },
    {
      path: '/operation/monitor/',
      name: 'monitor',
      component: monitor,
      menu: globalTitle.SETTING,
      meta: {
        title: 'Operation Log',
        permList: [],
      },
    },
    {
      path: '/sml-creative',
      name: 'smartlink creative',
      component: smlCreative,
      menu: globalTitle.SETTING,
      meta: {
        title: '4S Creative',
        permList: ['setting.smartlink_creative'],
      },
    },
    {
      path: '/sml-creative/create',
      name: 'add-creative',
      component: addCreative,
      meta: {
        title: 'Add Creative',
        permList: ['setting.smartlink_creative'],
      },
    },
    {
      path: '/sml-creative/edit/:id',
      name: 'edit-creative',
      component: addCreative,
      meta: {
        title: 'Edit Creative',
        permList: ['setting.smartlink_creative'],
      },
    },
    {
      path: '/parse-tid/',
      name: 'parse-tid',
      component: parseTid,
      menu: globalTitle.SETTING,
      meta: {
        title: 'Parse Transaction Id',
        permList: false,
      },
    },
    {
      path: '/rejection-monitoring/',
      name: 'rejection-monitoring',
      component: rejectionMonitoring,
      menu: globalTitle.SETTING,
      meta: {
        title: 'Rejection Monitoring',
        permList: false,
      },
    },
    /* Authorization */
    {
      path: '/user/list',
      name: 'user',
      component: users,
      menu: globalTitle.PERMISSION,
      meta: {
        title: 'Employees',
        permList: ['auth.view_employees'],
      },
    },
    {
      path: '/user/team',
      name: 'team',
      component: teams,
      menu: globalTitle.PERMISSION,
      meta: {
        title: 'Department',
        permList: ['auth.view_department'],
      },
    },
    {
      path: '/user/role',
      component: subRouteView(),
      children: [
        {
          path: '',
          name: 'role',
          component: roles,
          menu: globalTitle.PERMISSION,
          meta: {
            title: 'Role',
            permList: ['auth.view_role'],
          },
        },
        {
          path: 'setting/:id',
          name: 'role-setting',
          component: roleSetting,
          meta: {
            title: 'Role Setting',
          },
        },
      ],
    },
    /* pushgo */
    {
      path: '/pushgo/audience',
      component: subRouteView(),
      children: [
        {
          path: '',
          name: 'audience',
          component: audience,
          menu: globalTitle.PUSHGO,
          meta: {
            title: 'Audiences',
            permList: ['pushgo.view_push_user'],
          },
        },
      ],
    },
    {
      path: '/pushgo/sites',
      component: subRouteView(),
      children: [
        {
          path: '',
          name: 'sites',
          component: sites,
          menu: globalTitle.PUSHGO,
          meta: {
            title: 'Site List',
            permList: ['pushgo.view_sites'],
          },
        },
      ],
    },
    /* websiteManagement */
    {
      path: '/website/event/list',
      name: 'eventsList',
      component: eventsList,
      menu: globalTitle.WEBSITE_MANAGEMENT,
      meta: {
        title: 'Events List',
        permList: ['website.view_event'],
      },
    },
    {
      path: '/website/event/create',
      name: 'add-event',
      component: addEvent,
      meta: {
        title: 'Add Event',
        permList: ['website.create_event'],
      },
    },
    {
      path: '/website/event/edit/:id',
      name: 'edit-event',
      component: addEvent,
      meta: {
        title: 'Edit Event',
        permList: ['website.edit_event'],
      },
    },
    {
      path: '/website/resource/list',
      name: 'resourceList',
      component: resourceList,
      menu: globalTitle.WEBSITE_MANAGEMENT,
      meta: {
        title: 'Resource List',
        permList: ['website.view_resource'],
      },
    },
    {
      path: '/website/resource/create',
      name: 'add-resource',
      component: addResource,
      meta: {
        title: 'Add Resource',
        permList: ['website.create_resource'],
      },
    },
    {
      path: '/website/resource/edit/:id',
      name: 'edit-resource',
      component: addResource,
      meta: {
        title: 'Edit Resource',
        permList: ['website.edit_resource'],
      },
    },
    {
      path: '/online-earning/news/list',
      name: 'news-list',
      component: newsList,
      menu: globalTitle.ONLINE_EARNING,
      meta: {
        title: 'News List',
        permList: ['online_earning.view_news'],
      },
    },
    {
      path: '/online-earning/news/create',
      name: 'add-news',
      component: addNews,
      meta: {
        title: 'Add News',
      },
    },
    {
      path: '/online-earning/news/edit/:id',
      name: 'edit-news',
      component: addNews,
      meta: {
        title: 'Edit News',
      },
    },
    {
      path: '/online-earning/app/list',
      name: 'app-list',
      component: appList,
      menu: globalTitle.ONLINE_EARNING,
      meta: {
        title: 'App List',
      },
    },
    {
      path: '/online-earning/app/create',
      name: 'add-app',
      component: addApp,
      meta: {
        title: 'Add App',
      },
    },
    {
      path: '/online-earning/app/edit/:id',
      name: 'edit-app',
      component: addApp,
      meta: {
        title: 'Edit App',
      },
    },
    {
      path: '/online-earning/app/detail/:id',
      name: 'app-detail',
      component: addApp,
      meta: {
        title: 'App detail',
      },
    },
    {
      path: '/online-earning/activity',
      name: 'activity',
      component: activity,
      menu: globalTitle.ONLINE_EARNING,
      meta: {
        title: 'Activity',
      },
    },
    {
      path: '/online-earning/activity/create',
      name: 'add-activity',
      component: addActivity,
      meta: {
        title: 'Add Activity',
      },
    },
    {
      path: '/online-earning/activity/edit/:id',
      name: 'edit-activity',
      component: addActivity,
      meta: {
        title: 'Edit Activity',
      },
    },
    {
      path: '/online-earning/activity/detail/:id',
      name: 'activity-detail',
      component: addActivity,
      meta: {
        title: 'Activity detail',
      },
    },
    /* Data */
    {
      path: '/report/',
      name: 'report-common',
      component: reportCommon,
      menu: globalTitle.REPORT,
      meta: {
        title: 'Report',
        permList: [
          'report.ader_manage',
          'report.aff_manage',
          'report.global_manage',
          'report.only_invalid_click_report',
          'report.new_emp',
        ],
      },
    },
    {
      path: '/otc-detail-data',
      component: subRouteView(),
      children: [
        {
          path: 'list',
          name: 'otc-detail-data',
          component: otcDetailData,
          menu: globalTitle.REPORT,
          meta: {
            title: 'OTC Detail Data',
            permList: ['report.otc_detail_data'],
          },
        },
      ],
    },
    /* Feedback */
    {
      path: '/feedback',
      name: 'feedback',
      component: feedback,
      menu: globalTitle.FEEDBACK,
      meta: {
        title: 'Feedback',
        permList: ['feedback.view_feedback'],
      },
    },
    {
      path: '/support',
      name: 'support',
      component: support,
      menu: globalTitle.FEEDBACK,
      meta: {
        title: 'Support',
        permList: ['support.view_support'],
      },
    },
  ],
  scrollBehavior(to, from, savePosition) {
    return { x: 0, y: 0 }
  },
})

const push = router.push.bind(router)
router.push = (location, onComplete, onAbort) => {
  const navigation = push(location, onComplete, onAbort)
  if (onComplete || onAbort || !navigation) return navigation
  return navigation.catch(error => {
    // 重复点击当前菜单视为原地导航；加载和权限等真实失败继续交给调用方。
    if (error && error.name === 'NavigationDuplicated') return router.currentRoute
    throw error
  })
}

let goToNext = (to, next, router) => {
  const vm = router.app
  if (!Array.isArray(to.meta.permList)) {
    next()
    document.title = to.meta.title ? `${to.meta.title} | Demeter` : 'Demeter'
  } else {
    if (
      vm.$store.state.user.is_superuser ||
      hasIntersect(to.meta.permList, vm.$store.state.permList)
    ) {
      next()
      document.title = to.meta.title ? `${to.meta.title} | Demeter` : 'Demeter'
    } else {
      router.push('/')
    }
  }
}

router.onError(notify)

router.beforeEach((to, from, next) => {
  const vm = router.app
  console.log('-------------', vm._isMounted)
  if (!vm._isMounted) {
    Promise.all([
      vm.$options.store.dispatch('getUserInfo'),
      vm.$options.store.dispatch('getPermission'),
    ])
      .then(([, permissions]) => {
        // MENU 依赖用户的 is_superuser，须在两项初始化均成功后生成。
        vm.$options.store.commit('MENU', permissions)
        goToNext(to, next, router)
      })
      .catch(() => next(false))
  } else {
    goToNext(to, next, router)
  }
})

export default router
